// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { PersonDto } from "../../types";
import type { UseApiFetchOptions, UseApiFetchResponse } from "../../composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { Ref, MaybeRef } from "vue";
import {
    $apiFetch,
    computed,
    unref,
    useApiFetch,
    useFetchDependencies
} from "#imports";

export function usePersonResource () {

    /**
     * Get a specific person by ID
     * @param id The ID of the person to load
     * @return A person record
     */
    function getById(
        id: MaybeRef<string>
    ) : UseApiFetchResponse<PersonDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/Person/{id}";

        const idUnref = unref( id );
        if (idUnref === undefined || idUnref === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idUnref));

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<PersonDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<PersonDto>( computedUrl, options_ );
    }

    return {
        getById,
    }
}


export function $personResource () {

    const dependencies_ = useFetchDependencies();

    /**
     * Get a specific person by ID
     * @param id The ID of the person to load
     * @return A person record
     */
    function getById(
        id: string
    ) {
        let url_ = "/api/Person/{id}";

        const idUnref = unref( id );
        if (idUnref === undefined || idUnref === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idUnref));

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<PersonDto>( url_, options_, dependencies_ );
    }

    return {
        getById,
    }
}